exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".menu-brush-1{fill:#f1faf9}.menu-brush-2{fill:#fff}.menu-brush-3{fill:#ee7470}.menu-brush-4{fill:#72cac2}.menu-brush-5{fill:#1e4e69}.menu-brush-6{fill:#f3586a}\n", ""]);
